module.exports = __webpack_public_path__ + "img/history11.d3e2b675.jpg";